/**
 * @generated SignedSource<<39a1c2c835a71aca2fe390632905c500>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSidebarFavorites_user$data = {
  readonly hasInternalUserPermission: boolean | null;
  readonly " $fragmentType": "PdpSharedSidebarFavorites_user";
};
export type PdpSharedSidebarFavorites_user$key = {
  readonly " $data"?: PdpSharedSidebarFavorites_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSidebarFavorites_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSidebarFavorites_user",
  "selections": [
    {
      "alias": "hasInternalUserPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "INTERNAL_ADMIN_USER"
        }
      ],
      "kind": "ScalarField",
      "name": "hasPermission",
      "storageKey": "hasPermission(name:\"INTERNAL_ADMIN_USER\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f3010ea4dfe8d6ca160288b017e17ffd";

export default node;
